import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { ENV, hasSupabase } from "./env";

// One shared Supabase client (the whole project has a single backend).
// If the backend isn't provisioned, we export null and every caller degrades
// gracefully — never a crash, never a hardcoded fallback.
export const supabase: SupabaseClient | null = hasSupabase
  ? createClient(ENV.supabaseUrl, ENV.supabaseAnonKey, {
      auth: { persistSession: false },
    })
  : null;
